"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResultComponent = ResultComponent;
const React = __importStar(require("react"));
const GraphQLQuery = __importStar(require("@genesys/client-core/lib/graphql-query"));
const Exporter = __importStar(require("@genesys/client-core/lib/exporter"));
const Elements = __importStar(require("@genesys/client-core/lib/elements"));
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const result_table_1 = require("../shared/result-table");
const resultQuery = (0, graphql_tag_1.default) `
  query TranslationSearchResultQuery(
    $translation: String!
    $languageCodes: [String!]!
  ) {
    product {
      translationOccurrrence(
        translation: $translation
        languageCodes: $languageCodes
      ) {
        textId
        languageCode
        database
        languageText
      }
    }
  }
`;
function ResultComponent(props) {
    return (React.createElement(GraphQLQuery.QueryProductSimple, { query: resultQuery, variables: {
            languageCodes: props.languageCodes,
            translation: props.translation
        } }, result => {
        const results = result.product.translationOccurrrence.map(mapResultToRow);
        const columns = createColumns(props.translation);
        return (React.createElement(Elements.StandardContainer, null,
            React.createElement(Elements.FlexContainerStack, null,
                React.createElement(Exporter.XlsxSingleSheetExport, { data: resultToFile(results, columns), filename: "translation-search" }, onClick => (React.createElement(Elements.StandardButton, { onClick: () => onClick() }, "Download")))),
            React.createElement(Elements.FlexContainerRowWithPadding, null,
                React.createElement(result_table_1.ResultTable, { columns: columns, results: results, itemsPerPage: 30 }))));
    }));
}
const resultToFile = (results, columns) => {
    // Extract headers from columns
    const headers = columns.map(column => column.header);
    // Map results to ordered arrays based on the order of columns
    const rows = results.map(result => columns.map(column => {
        return result[column.name];
    }));
    return [headers, ...rows];
};
function mapResultToRow(result) {
    return {
        textId: result.textId,
        languageCode: result.languageCode,
        database: result.database,
        languageText: result.languageText
    };
}
const createColumns = (searchString) => [
    { name: "textId", header: "TextId", rowRenderer: row => row.textId },
    {
        name: "languageCode",
        header: "LanguageCode",
        rowRenderer: row => row.languageCode
    },
    { name: "database", header: "Database", rowRenderer: row => row.database },
    {
        name: "languageText",
        header: "LanguageText",
        rowRenderer: row => (React.createElement(Highlight, { text: row.languageText, highlight: searchString }))
    }
];
const Highlight = ({ text, highlight }) => {
    if (!highlight.trim()) {
        return React.createElement("span", null, text);
    }
    const parts = text.split(new RegExp(`(${highlight})`, "gi"));
    return (React.createElement("span", null, parts.map((part, index) => part.toLowerCase() === highlight.toLowerCase() ? (React.createElement("mark", { key: index }, part)) : (part))));
};
//# sourceMappingURL=result-component.js.map